module.exports = __webpack_public_path__ + "img/Hypoxia-BRCA_10X_IDC.5b31013f.png";